import { BotLocale } from '@shared/index';

export interface BotLocaleOption {
    name: string;
    code: BotLocale;
}

// Sprachoptionen fuer Bot-Endnutzer-Texte (siehe bot/angular.json i18n.locales).
// Labels teilen sich die i18n-Keys mit embed-tab.component.ts, um Doppel-Uebersetzungen zu vermeiden.
export const BOT_LOCALE_OPTIONS: BotLocaleOption[] = [
    { name: $localize`:@@fusionconfig-systemlang-de:Deutsch`, code: 'de' },
    { name: $localize`:@@fusionconfig-systemlang-en:Englisch`, code: 'en' },
    { name: $localize`:@@fusionconfig-systemlang-fr:Französisch`, code: 'fr' },
    { name: $localize`:@@fusionconfig-systemlang-es:Spanisch`, code: 'es' },
    { name: $localize`:@@fusionconfig-systemlang-it:Italienisch`, code: 'it' },
    { name: $localize`:@@fusionconfig-systemlang-nl:Niederländisch`, code: 'nl' },
    { name: $localize`:@@fusionconfig-systemlang-nb:Norwegisch`, code: 'nb-no' },
    { name: $localize`:@@fusionconfig-systemlang-fr-be:Französisch (Belgien)`, code: 'fr-be' },
    { name: $localize`:@@fusionconfig-systemlang-nl-be:Niederländisch (Belgien)`, code: 'nl-be' },
    { name: $localize`:@@fusionconfig-systemlang-pl:Polnisch`, code: 'pl' },
    { name: $localize`:@@fusionconfig-systemlang-pt:Portugiesisch`, code: 'pt' },
    { name: $localize`:@@fusionconfig-systemlang-hu:Ungarisch`, code: 'hu' },
    { name: $localize`:@@fusionconfig-systemlang-ro:Rumänisch`, code: 'ro' },
    { name: $localize`:@@fusionconfig-systemlang-tr:Türkisch`, code: 'tr' },
    { name: $localize`:@@fusionconfig-systemlang-fi:Finnisch`, code: 'fi' },
    { name: $localize`:@@fusionconfig-systemlang-sv:Schwedisch`, code: 'sv' },
    { name: $localize`:@@fusionconfig-systemlang-da:Dänisch`, code: 'da' },
    { name: $localize`:@@fusionconfig-systemlang-cs:Tschechisch`, code: 'cs' },
    { name: $localize`:@@fusionconfig-systemlang-el:Griechisch`, code: 'el' }
];
